import { brand, manufacturerSKU, mmId, productEan, productRef, productWarranty } from '../translations';
const productTranslations: {
  [key: string]: string;
} = {
  warranty: productWarranty,
  ean: productEan,
  manufacturerSKU,
  productRef,
  brand,
  mmId
};
export const translateAttributeName = (name: string): string => productTranslations[name] || name;